import {
    api, C, sampleFields, sampleInventory, sampleTreatments,
    FRUITETI_CROPS, OPEN_FIELD_CROP_GROUPS, WMO_CODES,
    PERMANENT_CROP_KEYWORDS, OFFLINE_QUEUE_KEY
} from './context.js';
export async function fetchWeather(lat, lon) {
    const url = `/api/weather?lat=${lat}&lon=${lon}`;
    console.log('[AgriLog] Meteo fetch via proxy:', url);
    try {
        const res = await fetch(url);
        console.log('[AgriLog] Meteo status:', res.status);
        if (!res.ok) throw new Error('HTTP ' + res.status);
        const json = await res.json();
        console.log('[AgriLog] Meteo data ricevuto:', json.current);
        return json;
    } catch (e) {
        console.warn('[AgriLog] Meteo non disponibile:', e.message);
        return null;
    }
}

export async function initWeather(lat, lon) {
    const data = await fetchWeather(lat, lon);

    // --- Sidebar mini-widget ---
    const sideIcon  = document.getElementById('side-weather-icon');
    const sideSpeed = document.getElementById('side-wind-speed');
    const sideLabel = document.getElementById('side-wind-label');

    // --- Dashboard card ---
    const mainIcon    = document.getElementById('weather-main-icon');
    const tempEl      = document.getElementById('weather-temp');
    const condEl      = document.getElementById('weather-condition');
    const windEl      = document.getElementById('weather-wind');
    const humEl       = document.getElementById('weather-humidity');
    const rainEl      = document.getElementById('weather-rain');
    const alertDiv    = document.getElementById('weather-alert');
    const alertText   = document.getElementById('weather-alert-text');
    const irrBadge    = document.getElementById('weather-irr-badge');

    if (!data) {
        if (sideLabel) sideLabel.textContent = 'Meteo non disponibile';
        if (alertText) alertText.textContent = 'Impossibile recuperare i dati meteo. Controlla la connessione.';
        return;
    }

    // Attempt to get location name
    const locNameEl = document.getElementById('weather-location-name');
    if (locNameEl) {
        locNameEl.textContent = '...';
        fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`, { headers: { 'User-Agent': 'AgriLog/1.0' } })
            .then(r => r.json())
            .then(json => {
                if (json && json.address) {
                    const city = json.address.village || json.address.town || json.address.city || json.address.county || '';
                    const state = json.address.state || '';
                    locNameEl.textContent = city ? `(${city}, ${state})` : '';
                }
            })
            .catch(e => {
                console.warn('[AgriLog] Reverse geocoding error:', e);
                locNameEl.textContent = '';
            });
    }

    const c        = data.current;
    const wmoCode  = c.weather_code;
    const wmo      = WMO_CODES[wmoCode] || { label: 'N/D', icon: 'fa-circle-question', cls: 'text-muted' };
    const wind     = c.wind_speed_10m;
    const temp     = c.temperature_2m;
    const humidity = c.relative_humidity_2m;
    const rain24   = (data.daily && data.daily.precipitation_sum) ? data.daily.precipitation_sum[0] : 0;

    // Update sidebar
    if (sideIcon)  { sideIcon.className = `fa-solid ${wmo.icon} ${wmo.cls}`; }
    if (sideSpeed) sideSpeed.textContent = `${temp}\u00b0C  Â·  ${wind} km/h`;
    if (sideLabel) sideLabel.textContent = wmo.label;

    // Update dashboard card
    if (mainIcon) mainIcon.className = `fa-solid ${wmo.icon} weather-large-icon ${wmo.cls}`;
    if (tempEl)   tempEl.textContent  = `${temp}\u00b0C`;
    if (condEl)   condEl.textContent  = wmo.label;
    if (windEl)   windEl.textContent  = `${wind} km/h`;
    if (humEl)    humEl.textContent   = `${humidity}%`;
    if (rainEl)   rainEl.textContent  = `${rain24 || 0} mm`;

    // Irrorazione assessment
    const windOk  = wind < 20;
    const rainOk  = rain24 < 5;
    const wmoOk   = ![65, 82, 95, 99].includes(wmoCode);
    const allOk   = windOk && rainOk && wmoOk;

    if (alertDiv) {
        alertDiv.className = 'weather-alert ' + (allOk ? 'alert-success' : 'alert-warning');
    }
    if (alertText) {
        if (allOk) {
            alertText.innerHTML = '\u2705 Condizioni favorevoli per irrorazione. Vento contenuto e nessun rischio dilavamento nelle prossime ore.';
        } else {
            const reasons = [];
            if (!windOk)  reasons.push(`vento elevato (${wind} km/h)`);
            if (!rainOk)  reasons.push(`pioggia nelle ultime 24h (${rain24} mm)`);
            if (!wmoOk)   reasons.push('precipitazioni in corso o temporale');
            alertText.innerHTML = `\u26a0\ufe0f Condizioni sfavorevoli: ${reasons.join(', ')}. Evitare irrorazioni.`;
        }
    }
    if (alertDiv) alertDiv.querySelector('i.fa-spinner')?.remove();
    if (irrBadge) {
        irrBadge.className = 'badge ' + (allOk ? 'badge-success' : 'badge-warning');
        irrBadge.textContent = allOk ? 'Meteo OK' : 'Attenzione';
    }
}
